import { Link } from "@inertiajs/react";
import Callout from "@/components/help/Callout";
import Screenshot from "@/components/help/Screenshot";
import { LockedCampaignHero } from "@/components/schools/DashboardHeros";
import {
  MEMBERSHIP_ADMIN,
  CAMPAIGN_LOCKED,
  SCHOOL_MILESTONES,
} from "@/help/fixtures";

const lockedFixture = {
  ...CAMPAIGN_LOCKED,
  classroom_count: 9,
  student_count: 184,
  edit_path: "#",
  milestones: SCHOOL_MILESTONES,
};

export default function AfterTheCampaign() {
  return (
    <>
      <p>
        When the end date arrives, reading wraps up — but the campaign isn't quite over. Donations stay open a while longer (a week, unless you chose differently when planning), then everything settles into the final results.
      </p>

      <h2>Late donations</h2>
      <p>
        When reading ends, we email families that it's their last chance to log minutes and share (unless your school has switched that email off). This is usually when the most donations roll in: families do one last share, and donors who've been meaning to give finally click. Families get a short catch-up window to log their last minutes (until 9 AM the next morning by default), then only donations carry on.
      </p>

      <Callout variant="tip" title="One more share goes a long way">
        <p>
          A short note from the school during these days — "we've raised $X toward our $Y goal, here's where each classroom stands" — usually pulls in another 10–20%. It's the easiest extra fundraising you'll do.
        </p>
      </Callout>

      <h2>The final results</h2>
      <p>
        When donations close (a week after the end date, unless you chose differently when planning), the campaign settles into its final form. We'll email a "final results" message to the whole school, donations close, and the dashboard freezes onto the leaderboard exactly as it stood. There's a button to start your next campaign whenever you're ready. Like the first, it goes live once its fee is paid and we've approved it.
      </p>
      <Screenshot caption="The final-results dashboard">
        <LockedCampaignHero campaign={lockedFixture} membership={MEMBERSHIP_ADMIN} new_campaign_path="#" />
      </Screenshot>

      <p>
        After this point, refunds still work in the rare case someone needs one — they just don't change the rankings. Parents can still find their take-home sheet weeks later and look at how everything turned out. And you can revisit any past campaign whenever you want using the <strong>Past campaigns</strong> button on your dashboard.
      </p>

      <h2>Don't forget the prizes</h2>
      <p>
        Whether the campaign is still running or already wrapped, students who earned a prize still need to get it. Pop into the <Link href="/help/articles/handing-out-student-prizes">prize tracker</Link> to make sure nobody's been missed.
      </p>

      <h2>What's next</h2>
      <ul>
        <li><Link href="/help/articles/handing-out-student-prizes">Handing out student prizes</Link>.</li>
        <li><Link href="/help/articles/creating-a-campaign">Creating your next campaign</Link>.</li>
      </ul>
    </>
  );
}
